module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }), _vm._v(" Lisa's Day-Long Muffins")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("These muffins are hearty enough to carry you through a long distance ride, according to Lisa Peters from Concord, New Hampshire, who shared her recipe with us. Bake them the day before you head out on an all-day ride. Enjoy them before you roll out in the morning and make sure you pack a few into your saddlebags for later, when the bike and your own tank need a refill.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup (1 stick) butter, softened")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup packed brown sugar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("large eggs, lightly beaten")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("tablespoons milk")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("tablespoon vanilla extract")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cups all-purpose flour")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoon ground cinnamon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoon ground nutmeg")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoon salt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("teaspoon baking powder")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cups mashed ripe bananas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup semisweet chocolate chips")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("¾")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup chopped nuts (optional)")])])])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Preheat the oven to 350°F. Grease three 6-cup muffin tins.")]), _vm._v(" "), _c('li', [_vm._v("In a medium-size mixing bowl, cream together the butter and brown sugar. Add the eggs and mix well. Add the milk and vanilla and blend thoroughly.")]), _vm._v(" "), _c('li', [_vm._v("In a large mixing bowl, sift together the flour, cinnamon, nutmeg, salt, and baking powder. Add the brown sugar mixture and stir just until blended. Add the bananas and mix till smooth. Fold in the chocolate chips and nuts, if using.")]), _vm._v(" "), _c('li', [_vm._v("Divide the batter among the muffin cups and bake until golden brown and a toothpick inserted in the middle comes out clean, 35 to 45 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES ABOUT")]), _vm._v(" 18 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MUFFINS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d5053e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c002.vue
// module id = 84
// module chunks = 0